module.exports = __webpack_public_path__ + "img/timeline-graphic.7917ec12.png";